import {
  MatchingResultDto,
  MatchRunDto,
  MatchRunDetailDto,
  CandidateMatchDto,
  ShortlistItemDto,
  AddToShortlistRequestDto,
  UpdateShortlistItemRequestDto,
  UpdateCandidateMatchRequestDto,
  ShortlistDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const matchingApi = {
  // Run matching for an inquiry
  async runMatching(inquiryId: string): Promise<MatchingResultDto> {
    return API.post<MatchingResultDto>(`/matching/inquiries/${inquiryId}/run`).then((res) => res.data);
  },

  // Get all match runs for an inquiry
  async getMatchRuns(inquiryId: string): Promise<MatchRunDto[]> {
    return API.get<MatchRunDto[]>(`/matching/inquiries/${inquiryId}/runs`).then((res) => res.data);
  },

  async getMatchRunDetail(runId: string): Promise<MatchRunDetailDto> {
    return API.get<MatchRunDetailDto>(`/matching/runs/${runId}`).then((res) => res.data);
  },

  // Get all candidate matches for an inquiry
  async getCandidateMatches(inquiryId: string): Promise<CandidateMatchDto[]> {
    return API.get<CandidateMatchDto[]>(`/matching/inquiries/${inquiryId}/candidates`).then((res) => res.data);
  },

  async getShortlist(inquiryId: string): Promise<ShortlistDto|null> {
    return API.get<ShortlistDto>(`/matching/inquiries/${inquiryId}/shortlist`).then((res) => res.data);
  },

  async submitInvitations(inquiryId: string): Promise<ShortlistDto> {
    return API.post<ShortlistDto>(`/matching/inquiries/${inquiryId}/shortlist/submit-invitations`).then(
      (res) => res.data
    );
  },

  // Add candidate to shortlist
  async addToShortlist(inquiryId: string, dto: AddToShortlistRequestDto): Promise<ShortlistItemDto> {
    return API.post<ShortlistItemDto>(`/matching/inquiries/${inquiryId}/shortlist/items`, dto).then((res) => res.data);
  },

  async updateShortlistItem(itemId: string, dto: UpdateShortlistItemRequestDto): Promise<ShortlistItemDto> {
    return API.patch<ShortlistItemDto>(`/matching/shortlist-items/${itemId}`, dto).then((res) => res.data);
  },

  async updateCandidateMatch(
    candidateMatchId: string,
    dto: UpdateCandidateMatchRequestDto,
  ): Promise<CandidateMatchDto> {
    return API.patch<CandidateMatchDto>(`/matching/candidate-matches/${candidateMatchId}`, dto).then(
      (res) => res.data,
    );
  },
};
